import _ from 'lodash';
import { IsNullOrWhiteSpace, IsNullOrEmpty } from "./Micro";
// =======================================================================================================
export class DomUtils {
    // ------------------------------------------------------------------------------------------------------
    static async LoadImage(value: string): Promise<HTMLImageElement> {
        return await new Promise<HTMLImageElement>((resolve, reject) => {
            if (IsNullOrEmpty(value) || IsNullOrWhiteSpace(value)) {
                reject(new Error(""));
            }
            else {
                // create image element
                let img = document.createElement("img");
                img.crossOrigin = "Anonymous";

                // handle error
                img.onerror = (er: ErrorEvent) => {
                    reject(new Error(er.message));
                };

                // handle success
                img.onload = () => {
                    resolve(img);
                };
                // assign source
                img.src = value;
            }
        });
    }
    // ------------------------------------------------------------------------------------------------------
    static IMG_TYPE_PNG = 'png';
    static IMG_TYPE: string[] = [DomUtils.IMG_TYPE_PNG, 'gif', 'bmp', 'jpeg', 'webp'];
    // ------------------------------------------------------------------------------------------------------
    static resize(img: HTMLImageElement, width: number, height: number, type: string, quality: number = 0.8) {
        if (this.IMG_TYPE.indexOf(type) < 0) {
            type = DomUtils.IMG_TYPE_PNG;
        }

        // calculate the width or height , maintaining aspect ratio
        var detImg = img.width / img.height;
        if ((width / height) > detImg) {
            height = width / detImg;
        } else {
            width = height * detImg;
        }

        // Create canvas for resize
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        (ctx as any).mozImageSmoothingEnabled = true;
        (ctx as any).webkitImageSmoothingEnabled = true;
        ctx.imageSmoothingEnabled = true;
        ctx.drawImage(img, 0, 0, width, height);

        // set background color to #fff while output type is NOT PNG
        if (type !== DomUtils.IMG_TYPE_PNG) {
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //ctx.globalCompositeOperation = '';
        }
        return canvas.toDataURL('image/' + type, quality);
    }
    // ------------------------------------------------------------------------------------------------------
    static async getResizedImage(
        value: string,
        maxWidth: number,
        maxHeight: number,
        outImageType: ImageFormat = "jpeg",
        outImageQuality: number = 0.8)
        : Promise<ImageInfo> {

        return await new Promise<ImageInfo>((resolve, reject) => {
            DomUtils.LoadImage(value).then((img) => {
                let newValue = value;
                let dimensions: { width: number, height: number } = {
                    width: img.width,
                    height: img.height
                };

                // check width/height and resize image if needed
                // if an url was provided, convert to base64
                // or the received type is not the same with the out image
                if (img.width > maxWidth ||
                    img.height > maxHeight ||
                    _.includes(value, "http") ||
                    !_.includes(value, "image/" + outImageType)) {
                    // calculate width and height, taking into account max width/height, maintaining aspect ratio
                    newValue = this.resize(img, maxWidth, maxHeight, outImageType, outImageQuality);
                }

                // get new value from resized image
                resolve({ src: newValue, width: dimensions.width, height: dimensions.height, aspectRatio: dimensions.width / dimensions.height });
            }).catch((reason: Error) => {
                reject(reason);
            });
        });
    }
    // ------------------------------------------------------------------------------------------------------
};
// ------------------------------------------------------------------------------------------------------
export interface ImageInfo {
    src: string;
    width: number;
    height: number;
    aspectRatio: number;
}
export type ImageFormat = "png" | "gif" | "bmp" | "jpeg" | "webp";
// ------------------------------------------------------------------------------------------------------